// extracted by mini-css-extract-plugin
export default {"root":"styles_root__fOseu","circularProgress":"styles_circularProgress__pYgMO"};